import type { ICreateElectionState, IGetElectionTypeStates } from '../../../interface/state/IElectionState';
import { electionTypeType } from '../../types';
import { createAPI, deleteByIdAPI, getAPI, getByIdAPI, updateByIdAPI } from '../api-utils';

export const create = createAPI<ICreateElectionState, { name: string }>({
	actionType: electionTypeType.create,
	url: '/api/v1/ElectionType',
});

export const get = getAPI({
	actionType: electionTypeType.get,
	url: '/api/v1/ElectionType',
	type: 'core',
});

export const getByID = getByIdAPI<IGetElectionTypeStates>({
	actionType: electionTypeType.getByID,
	url: '/api/v1/ElectionType',
});

export const updateByID = updateByIdAPI<undefined, { name: string }>({
	actionType: electionTypeType.updateByID,
	url: '/api/v1/ElectionType',
});

export const deleteByID = deleteByIdAPI({
	actionType: electionTypeType.deleteByID,
	url: '/api/v1/ElectionType',
});
